import "../../chunk-D57E6H3M.mjs";

// src/domain/chat/message-visibility.ts
import { ChatRole, ChatStreamStatus } from "./types.mjs";
function shouldRenderChatMessage(message, sessionStatus) {
  if (message.role === ChatRole.User) return !!message.content;
  if (message.role === ChatRole.Assistant) return (message.timeline?.length ?? 0) > 0 || isFailedEmptyReply(message, sessionStatus);
  return false;
}
function isFailedReply(message, sessionStatus) {
  return message.role === ChatRole.Assistant && sessionStatus === ChatStreamStatus.Failure;
}
function isFailedEmptyReply(message, sessionStatus) {
  return message.role === ChatRole.Assistant && isFailedReply(message, sessionStatus) && (message.timeline?.length ?? 0) === 0;
}
function hasSubstantiveAssistantContent(content, timeline) {
  if (content?.trim()) return true;
  return (timeline ?? []).some(
    (item) => item.type === "product_list" && (item.products?.length ?? 0) > 0 || item.type === "product_card" && item.product != null || item.type === "order_status" && (item.orders?.length ?? 0) > 0 || item.type === "content" && Boolean(item.content?.trim()) || item.type === "clarifying_questions" && (item.questions?.length ?? 0) > 0 || item.type === "inline_form" && (item.fields?.length ?? 0) > 0 || item.type === "possible_replies" && (item.possibleReplies?.length ?? 0) > 0 || item.type === "pending_action" || item.type === "applied_change" || item.type === "tool_card" && item.card != null
  );
}
export {
  hasSubstantiveAssistantContent,
  isFailedEmptyReply,
  isFailedReply,
  shouldRenderChatMessage
};
//# sourceMappingURL=message-visibility.mjs.map